import React from "react";
import "./StyledBgContainer.css";

interface StyledBgContainerProps {
  children: React.ReactNode;
  className?: string;
}

const StyledBgContainer: React.FC<StyledBgContainerProps> = ({
  children,
  className,
}) => {
  return <div className={`bg-container ${className}`}>{children}</div>;
};

export default StyledBgContainer;
